<template>
    <v-container fill-height fluid grid-list-xl>
        <v-layout justify-center wrap>
            <v-flex md12>
                <material-card color="green" title="Lista de carreras" text="El template viene con subtitulos">
                    <v-data-table :headers="headers" :items="items" hide-default-footer>
                        <template slot="headerCell" slot-scope="{ header }">
                            <span
                                class="subheading font-weight-light text-success text--darken-3"
                                v-text="header.text"
                            />
                        </template>
                        <template slot="items" slot-scope="{ item }">
                            <td>{{ item.carrera }}</td>
                            <td>{{ item.universidad }}</td>
                            <td>{{ item.sede }}</td>
                        </template>
                        <template v-slot:item.action="{ item }">
                            <v-icon small class="mr-2" @click="editItem()">
                                mdi-edit
                            </v-icon>
                        </template>
                    </v-data-table>
                </material-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import Vue from "vue"

export default Vue.extend({
    data: () => ({
        headers: [
            {
                sortable: false,
                text: "Carrera",
                value: "carrera"
            },
            {
                sortable: false,
                text: "Universidad",
                value: "universidad"
            },
            {
                sortable: false,
                text: "Sede",
                value: "sede"
            }
        ],
        items: [
            {
                carrera: "Medicina General",
                universidad: "Pontificia Universidad Católica de Chile",
                sede: "Casa central"
            },
            {
                carrera: "Medicina General",
                universidad: "Pontificia Universidad Católica de Chile",
                sede: "Casa central"
            },
            {
                carrera: "Medicina General",
                universidad: "Pontificia Universidad Católica de Chile",
                sede: "Casa central"
            }
        ]
    }),
    methods: {
        editItem() {}
    }
})
</script>
